import updateOrdinals from './updateOrdinals';

export const sortCardsOnDropBetweenCards = (params) => {
  const { afterOrgNodeOrdinal, currOrgNodeOrdinal, orgIndex, editor } = params;
  let lowerIndex;
  let upperIndex;
  let ordinalNo;
  if (afterOrgNodeOrdinal > currOrgNodeOrdinal) {
    ordinalNo = currOrgNodeOrdinal;
    lowerIndex = currOrgNodeOrdinal - 1;
    upperIndex = orgIndex + 1;
  } else if (afterOrgNodeOrdinal < currOrgNodeOrdinal) {
    ordinalNo = afterOrgNodeOrdinal;
    lowerIndex = orgIndex;
    upperIndex = currOrgNodeOrdinal;
  }

  updateOrdinals({
    lowerIndex,
    upperIndex,
    editor,
    ordinalNo,
  });
};

export const sortCardsOnDropAtEnd = (params) => {
  const { currOrgNodeOrdinal, editorDocumentNodesSize, editor } = params;
  const lowerIndex = currOrgNodeOrdinal - 1;
  const upperIndex = editorDocumentNodesSize;
  const ordinalNo = currOrgNodeOrdinal;
  updateOrdinals({
    lowerIndex,
    upperIndex,
    editor,
    ordinalNo,
  });
};
